import Vue from 'vue'
import device from 'vue-device-detector-js'

Vue.use(device)